import { contactSlice } from "../slices/contactSlice";
import { productsSlice } from "../slices/productSlice";

export const { setSelectedCategory } = productsSlice.actions;
export const { updateFormData, setSubmitting, setSubmitSuccess, resetForm } =
  contactSlice.actions;
